/**
 * utils/slugify.ts
 *
 * Función pura de normalización de strings a slug.
 *
 * GEMELO EXACTO de `utils/slugify.js` del backend. Si modificas el algoritmo
 * aquí, debes modificarlo allí también; si divergen, el preview en el form
 * dejará de coincidir con el slug persistido en BD.
 *
 * Ver utils/slugify.js para detalles del algoritmo.
 *
 * @author: Marcos Cordo
 * @version: 15/05/2026_1b.1
 */

export function slugify(input: string | null | undefined): string {
  if (!input) return '';
  return String(input)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}